export function numberToArray(n: number): any[] {
  if ( n < 0) {
    n = -n;
  }
  return Array(n);
}
